import React from "react";
import Navbar from "../components/navbar/navbar";
import Project from "../components/project/project";
import Contact from "../components/contact/contact";

const ContactPage: React.FC = () => {


  return (
    <>
      <Navbar/>
      <div className="page-content">
        <Contact/>
      </div>
    </>
  );
};

export default ContactPage;